import { render, staticRenderFns } from "./perm.vue?vue&type=template&id=77ecc82d&scoped=true"
import script from "./perm.vue?vue&type=script&lang=ts"
export * from "./perm.vue?vue&type=script&lang=ts"
import style0 from "./perm.vue?vue&type=style&index=0&id=77ecc82d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecc82d",
  null
  
)

export default component.exports